import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { XcentiumDynamicFormActions } from "@midland-industries/Store/Data/DynamicForms/DynamicFormReducer";
import { DynamicFormFieldModel } from "@midland-industries/Types/DynamicFormModels";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<XcentiumDynamicFormActions>;

type HandlerType = Handler<
    {
        formName: string;
        formField: DynamicFormFieldModel;
    },
    Props
>;

export const DispatchSetDynamicFormFieldValue: HandlerType = props => {
    props.dispatch({
        type: "Custom/DynamicForm/SetDynamicFormFieldValue",
        formName: props.parameter.formName,
        formField: props.parameter.formField,
    });
};

export const chain = [DispatchSetDynamicFormFieldValue];

const setDynamicFormFieldValue = createHandlerChainRunner(chain, "SetDynamicFormFieldValue");
export default setDynamicFormFieldValue;
